type ReceiptOwnerListener = () => void;

const receiptOwnerListeners = new Map<string, Set<ReceiptOwnerListener>>();

export const notifyReceiptOwner = (ownerKey: string): void => {
  receiptOwnerListeners.get(ownerKey)?.forEach((listener) => listener());
};

export const subscribeReceiptOwner = (
  ownerKey: string,
  listener: ReceiptOwnerListener,
): (() => void) => {
  const listeners = receiptOwnerListeners.get(ownerKey) ?? new Set();
  listeners.add(listener);
  receiptOwnerListeners.set(ownerKey, listeners);

  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) receiptOwnerListeners.delete(ownerKey);
  };
};
